'use client';
// This entire component is marked as client because the display is date-dependent and
// may not immediately update when using pure SSR. Otherwise just the button would be client-side.

import BorderedCtaContainer from 'components/containers/bordered-cta-container';
import { useRouter } from 'src/navigation';
import trackClickButton from 'lib/analytics/trackClickButton';
import { useTranslations } from 'next-intl';

const ExhibitionMemberPromo = ({
	ctaLink,
	description,
	displayThrough,
	title,
}: IExhibitionMemberPromo) => {
	const router = useRouter();
	const t = useTranslations('exhibition');

	let isExpired = !!displayThrough;

	if (displayThrough) {
		isExpired = new Date(`${displayThrough}T23:59:59`) < new Date();
	}

	const handleClick = () => {
		trackClickButton({
			buttonClicked: 'membership_promo',
			contentBlock: 'promo',
			contentName: 'Join today', // English only, SVP
			contentType: 'Membership',
		});
		router.push(ctaLink);
	};

	if (!isExpired && ctaLink) {
		return (
			<BorderedCtaContainer title={title} description={description}>
				<button className="tertiary" onClick={handleClick}>
					{t('joinToday')}
				</button>
			</BorderedCtaContainer>
		);
	} else {
		return null;
	}
};

interface IExhibitionMemberPromo {
	ctaLink?: string;
	description?: string;
	displayThrough?: string;
	title: string;
}

export default ExhibitionMemberPromo;
